export const communicationChannels = [
    {
        id: 'phone',
        name: 'Телефон',
        logo: '/channels/phone.png',
        description: 'Голосовой агент отвечает на звонки',
    },
    {
        id: 'site-chat',
        name: 'Чат на сайте',
        logo: '/channels/site-chat.svg',
        description: 'Виджет на сайте отвечает посетителям 24/7',
    },
    {
        id: 'max',
        name: 'Мессенджер MAX',
        logo: '/channels/max.png',
        description: 'Общение с клиентами в MAX',
    },
    {
        id: 'vk',
        name: 'Группа ВКонтакте',
        logo: '/channels/vk.svg',
        description: 'Ответы в сообщениях сообщества VK',
    },
    {
        id: 'bitrix24',
        name: 'Bitrix24',
        logo: '/channels/bitrix24.png',
        description: 'Интеграция с открытыми линиями Bitrix24',
    },
    {
        id: 'crm',
        name: 'Ваша CRM',
        logo: '/channels/crm.svg',
        description: 'Подключение к вашей CRM и передача лидов в привычный процесс',
    },
];
